import * as _4 from 'lodash4';
import { AppointmentSchedulingConfiguration } from '../../config/appointment_scheduling_configuration';
import { UpcomingAppointmentsQuery } from '../../queries/upcoming_appointments_query';
import { MyAppointmentsService } from '../../services/my_appointments_service';
import { IAppointment } from '../../types/appointment_interfaces';

export class MyAppointmentsChildrenController {
  appointments: IAppointment[];
  showReminders: boolean;
  upcomingAppointments: IAppointment[];
  showNextMonthAppointmentsOnly: boolean;
  showPastAppointments: boolean;
  showAppointmentRequests: boolean;
  isUpcomingAppointmentsAvailable: boolean;
  isPastAppointmentsAvailable: boolean;
  constructor(
    private ngMyAppointmentsService: MyAppointmentsService,
    private ngUpcomingAppointmentsQuery: UpcomingAppointmentsQuery,
    private ngAppointmentSchedulingConfiguration: AppointmentSchedulingConfiguration
  ) {}

  $onInit(): void {
    this.appointments = this.ngMyAppointmentsService.appointments;
    this.showReminders = this.ngMyAppointmentsService.showReminders;
    this.upcomingAppointments = this.ngMyAppointmentsService.upcomingAppointments;
    this.showNextMonthAppointmentsOnly = this.ngMyAppointmentsService.showNextMonthAppointmentsOnly;
    this.showPastAppointments = this.ngMyAppointmentsService.showPastAppointments;
    this.showAppointmentRequests = this.ngMyAppointmentsService.showAppointmentRequests;
    this.isUpcomingAppointmentsAvailable = this.ngMyAppointmentsService.isUpcomingAppointmentsAvailable;
    this.isPastAppointmentsAvailable = this.ngMyAppointmentsService.isPastAppointmentsAvailable;
  }

  appointmentRequestActive(): boolean {
    return this.showAppointmentRequests && this.ngUpcomingAppointmentsQuery.result().appointmentRequests.length > 0;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-appointments/src/views/my_appointments/my_appointments_children_controller.ts